import { Link } from 'react-router-dom';
import './page-header.scss';

const PageHeader = ({
  lastPage, lastPageLink, title, subtitle,
}) => (
  <div className="page-header">
    {lastPage && lastPageLink && (
      <div>
        <Link to={lastPageLink} className="ff-graphik-medium fw-normal fs-p3 back-button pointer align-items-center td-none">
          <svg title="Back Arrow" className="m-r-8" width="14" height="13" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
              <path d="M0.691893 5.96967C0.398999 6.26256 0.398999 6.73744 0.691893 7.03033L5.46486 11.8033C5.75776 12.0962 6.23263 12.0962 6.52552 11.8033C6.81842 11.5104 6.81842 11.0355 6.52552 10.7426L2.28288 6.5L6.52552 2.25736C6.81842 1.96447 6.81842 1.48959 6.52552 1.1967C6.23263 0.903806 5.75776 0.903806 5.46486 1.1967L0.691893 5.96967ZM13.5 5.75L1.22222 5.75L1.22222 7.25L13.5 7.25L13.5 5.75Z" fill="#745FCC" />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="14" height="12" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          {lastPage}
        </Link>
      </div>
    )}
    <div className="page-header__title">
      <h3 className="page-header__title--h3">{title}</h3>
      <p className="page-header__title--p">{subtitle}</p>
    </div>
  </div>
);

export default PageHeader;
